import React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Container, Row } from "reactstrap";

import routes from "routes.js";

const Error = props => {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/errors') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <Container className="mt--8 pb-5">
      <Row className="justify-content-center">
        <Switch>
          {getRoutes(routes[3].routes)}
          <Redirect from="*" to="/errors/error-404" />
        </Switch>
      </Row>
    </Container>
  );
};

export default Error;
